import { useContext } from 'react';
import { Button } from 'primereact/button';
import { LayoutContext } from '@/layout/context/context';
import { useNavigate } from 'react-router';
import { cn } from '@/helpers/utils/functionality-utils';

const NotFoundPage = ({ className }: { className?: string }) => {
  const { theme } = useContext(LayoutContext);
  const nav = useNavigate();
  return (
    <div
      className={cn(
        'flex min-h-screen min-w-[100vw] items-center justify-center overflow-hidden bg-surface-50',
        className,
      )}
    >
      <div className="flex flex-col items-center justify-center">
        <img
          src={`/assets/images/logo/logo-${
            theme === 'light' ? 'dark' : 'light'
          }-512.png`}
          alt="Sakai logo"
          style={{ height: '200px', width: '200px' }}
          className="mb-8 shrink-0"
        />
        <div
          style={{
            borderRadius: '56px',
            padding: '0.3rem',
            background:
              'linear-gradient(180deg, rgba(0, 150, 136, 0.4) 10%, rgba(0, 150, 136, 0) 30%)',
          }}
        >
          <div
            className="smpx-8 flex w-full flex-col items-center bg-surface-0 px-8 py-8"
            style={{ borderRadius: '53px' }}
          >
            <span className="text-3xl font-bold text-teal-500">404</span>
            <h1 className="mb-2 text-5xl font-bold text-surface-900">
              Not Found
            </h1>
            <div className="mb-8 text-surface-600">
              Requested resource is not available
            </div>
            <Button
              icon="pi pi-arrow-left"
              label="Go to Dashboard"
              text
              onClick={() =>
                nav('/main/dashboard', {
                  viewTransition: true,
                })
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
